import React from 'react'
import { css } from '@emotion/core'
import { boolAttr } from '@fs/zion-frontend-friends'

const rainbowDividerCss = css`
  height: 1px;
  margin: 4px 28px;
  background: linear-gradient(90deg, #00a7e7 0%, #d83b95 100%);
  &[flavor='blueberry'],
  &[flavor='blackberry'] {
    background: linear-gradient(90deg, #00a7e7 0%, #d83b95 100%);
  }
  &[flavor='apple'] {
    background: linear-gradient(90.52deg, #00b1cf 0%, #7fc350 100%);
  }
  &[flavor='salmon'] {
    background: linear-gradient(90deg, #d83b95 0%, #ffcc5c 100%);
  }
  &[flavor='mystery'] {
    background: #00b1cf;
  }
  &[full] {
    margin: 0;
  }
  &[thick] {
    height: 2px;
  }
`

export default function RainbowDivider({ full, thick, flavor = 'blueberry' }) {
  return <div full={boolAttr(full)} css={rainbowDividerCss} thick={boolAttr(thick)} flavor={flavor} />
}
